import { RequestConfig } from 'common/types/api'

export const WATER_QUALITY_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/water-quality' },
  getLineChart: { method: 'GET', url: '/water-quality/line-chart' },
  create: { method: 'POST', url: '/water-quality' },
  edit: { method: 'PATCH', url: '/water-quality' },
  delete: { method: 'DELETE', url: '/water-quality' },
  getRecent: { method: 'GET', url: '/water-quality/recent' },
  getToday: { method: 'GET', url: '/water-quality/today' },
  getByDate: { method: 'GET', url: '/water-quality/by-date' },
}

export const WATER_MINERAL_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/water-mineral' },
  getLineChart: { method: 'GET', url: '/water-mineral/line-chart' },
  create: { method: 'POST', url: '/water-mineral' },
  edit: { method: 'PATCH', url: '/water-mineral' },
  delete: { method: 'delete', url: '/water-mineral' },
}

export const WATER_VIBRIO_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/water-vibrio' },
  getLineChart: { method: 'GET', url: '/water-vibrio/line-chart' },
  create: { method: 'POST', url: '/water-vibrio' },
  edit: { method: 'PATCH', url: '/water-vibrio' },
  delete: { method: 'delete', url: '/water-vibrio' },
}
